import Categorypic from "../../components/categorypiker/Categorypic";
import getMeetingTime from "./utility/getMeetingTime";

const Header = ({ info, onClick }) => {
  return (
    <div 
      className="heaerdmeeting" 
      onClick={onClick}
      style={{ cursor: "pointer" }}
    >
      <div style={{ display: "flex", gap: "10px" }}>
        <div style={{ height: "50px", width: "50px" }}>
          <Categorypic iswidth={true} categoryID={info?.categoryid} />
        </div>

        <div>
          <p className="meetname">{info?.name}</p>
          <div className="meetingtimedetails">
            <span>{getMeetingTime(info?.scheduledtime?.date)}</span> - 
             <span> {getMeetingTime(info?.endtime?.date)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;